import React from 'react'
import ReactDOM from 'react-dom'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import queryString from 'query-string'
import { BrowserRouter as Router } from 'react-router-dom'
import { getPartnerId, getUserId } from 'utils/authLocalStorage'
import { amplitudeInit } from 'utils/amplitudeInit'
import './i18n'
import App from './App'
import 'utils/polyfills'
import { clearPositionState } from 'utils/postitionUtil'
import {
  getWWUserId,
  setWWDisclaimer,
  setWWNewChallenge,
} from 'utils/wwLocalStorage'
import { addGoogleTagManager, getErrorPagePath } from 'utils/basic'
import { BUGSNAG_API_KEY } from 'config'
import './index.scss'

Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  appVersion: process.env.REACT_APP_VERSION,
  user: {
    id: getUserId(),
  },
  onError: function (event) {
    return shouldReportError(event)
  },
})

const shouldReportError = (event) => {
  if (process.env.NODE_ENV === 'production') {
    return true
  }
  return false
}

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React)

clearPositionState()

const { client_id, guid, client_secret } = queryString.parse(
  window.location.search
)

if (client_id && guid && client_secret) {
  const currentUserId = getWWUserId()
  if (currentUserId !== guid) {
    setWWDisclaimer('')
    setWWNewChallenge('')
  } else {
    const partnerId = getPartnerId()
    if (partnerId) {
      amplitudeInit(partnerId)
      addGoogleTagManager(partnerId)
    }
  }
} else {
  const errorPagePath = getErrorPagePath()
  if (!window.location.pathname.includes(errorPagePath)) {
    window.location.replace(errorPagePath)
  }
}

ReactDOM.render(
  <ErrorBoundary>
    <Router>
      <App />
    </Router>
  </ErrorBoundary>,
  document.getElementById('root')
)
